import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import BackButton from "../../BackButton/BackButton";
import ScaffoldTitle from "../../Scaffold/components/ScaffoldTitle";

interface Props {
  isChattingWithOtherAgencies: boolean;
  onClickBack: () => void;
}

function MainActivityChatHeader(props: Props) {
  return (
    <MainActivityChatHeader.ChatsTitleContainer>
      <MainActivityChatHeader.BackButton>
        {props.isChattingWithOtherAgencies ? <BackButton onClick={props.onClickBack} /> : null}
      </MainActivityChatHeader.BackButton>
      <ScaffoldTitle label={translate(STRINGS.CHATS)} />
    </MainActivityChatHeader.ChatsTitleContainer>
  );
}

MainActivityChatHeader.ChatsTitleContainer = styled.div`
  display: flex;
  justify-content: center;
  /* adjustment */
  position: relative;
`;

MainActivityChatHeader.BackButton = styled.div`
  position: absolute;
  left: 0;
`;

export default MainActivityChatHeader;
